import React, { Component } from "react";
import ForStudentsDescription from "./ForStudentsDescription";

class ForStudents extends Component {
  state = {
    link: "",
  };

  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        <ForStudentsDescription type={this.state.link} />
      </div>
    );
  }
}

export default ForStudents;
